import axios from 'axios';

import Auth from '../lib/auth';
import { saveFile } from '../lib/content-lib';

// Download Pdf Actions
export function downloadPdf(htmlString, pdfOptions) {
    return async dispatch => {
        try {
            const token = Auth.getLocalJwt();
            const res = await axios.post('/api/content/headlessToPdf', { data: htmlString, options: pdfOptions }, {
                headers: { 'Authorization': 'Bearer ' + token },
                responseType: 'blob'
            });
            if( res.status === 200 ) {
                saveFile(res);
            } else {
                console.log('error, no data');
            }
        } catch (error) {
            console.log('error: ', error);
        }
    };
}


// WEBPACK FOOTER //
// ./src/actions/content.js